import React from "react";
import { Stack, Box, Button, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {AccountLevelArkchatPermission} from "../../utils/constant";

import { crossIcon, crossIconDiv } from "../../assets/commonFunction";
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
  ignorebtn: {
    color: "#183243",
    padding: "0.2rem 1rem",
    borderRadius: "0.2rem",
    bgcolor: "white",
    border: "1px solid #DB0011",
    boxShadow: "none",
    textTransform: "none",
    ":hover": {
      color: "#183243",
      padding: "0.2rem 1rem",
      borderRadius: "0.2rem",
      bgcolor: "white",
    },
  },
  acceptbtn: {
    color: "white",
    padding: "0.2rem 1rem",
    borderRadius: "0.2rem",
    bgcolor: "#DB0011",
    border: "1px solid #DB0011",
    boxShadow: "none",
    textTransform: "none",
    ":hover": {
      color: "white",
      padding: "0.2rem 1rem",
      borderRadius: "0.2rem",
      bgcolor: "#DB0011",
    },
  },
  radioStyle: {
    color: "#092C4C",
    "&.Mui-checked": {
      color: "#092C4C",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.2rem",
    },
  },
};

const MoreOptionDrawer = ({
  setDrawerOpen,
  selectedUserData,
  handlePermissionChange,
  handleRemoveUser,
  currentUserData,
}) => {
  return (
    <>
      <Box sx={classes?.drawerBody}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={classes.header}
        >
          <Typography sx={classes.iconDiv}>
            <CloseIcon
              sx={classes.iconn}
              onClick={() => setDrawerOpen(false)}
            />
          </Typography>
          <Typography color={"black"}>Manage User</Typography>
        </Stack>

        <Box width={"95%"} margin={"auto"} mt={"0.5rem"}>
          <Box>
            <Typography>Assign Rights</Typography>
            <Typography>
              Only the Owner or Admins can change user roles.
            </Typography>
          </Box>
          <Box>
            <RadioGroup
              onChange={(e) => handlePermissionChange(e, selectedUserData)}
              row
              sx={{ mt: "0.5rem" }}
            >
              <FormControlLabel
                value="admin"
                control={
                  <Radio
                    value="ADMIN"
                    checked={
                      AccountLevelArkchatPermission.ADMIN ===
                      selectedUserData.permission
                    }
                    sx={{
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                      "&.Mui-checked": {
                        color: "#000", // ✅ black when selected
                      },
                    }}
                  />
                }
                label="Admin"
                labelPlacement="start"
                sx={{
                  mr: 4,
                  "& .MuiFormControlLabel-label": {
                    marginRight: "8px",
                  },
                }}
              />

              <FormControlLabel
                value="user"
                control={
                  <Radio
                    value="USER"
                    checked={
                      AccountLevelArkchatPermission.USER ===
                      selectedUserData.permission
                    }
                    sx={{
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                      "&.Mui-checked": {
                        color: "#000",
                      },
                    }}
                  />
                }
                label="User"
                labelPlacement="start"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    marginRight: "8px",
                  },
                }}
              />
            </RadioGroup>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={"0.5rem"}
          >
            <Box>
              <Typography>Remove User</Typography>
              <Typography>
                Only the Owner or Admins can remove users.
              </Typography>
            </Box>
            <Button
              variant="outlined"
              onClick={() => handleRemoveUser(selectedUserData)}
              sx={{
                textTransform: "none",
                backgroundColor: "#ffffffffff",
                padding: "3px 25px",
                color: "#020202ff",
                fontSize: "0.78rem",
                minWidth: "unset",
                border: "1px solid #868484ff",
                minHeight: "unset",
                borderRadius: "0.15rem",
                whiteSpace: "nowrap",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#ffffffff",
                  color: "#000000ff",
                },
              }}
            >
              Remove
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default MoreOptionDrawer;
